export default __webpack_public_path__ + "static/thumbnail-a26b776acd36dc005e7ad392e6b45c5b.png";